/* global $:false */

export default class CarouselSlideshow {
  static init () {
    if (this.instances) {
      for (const instance of this.instances) {
        instance.stop()
      }
    }

    this.instances = $('.js-slideshow')
      .map(function () { return new CarouselSlideshow(this) })
      .get()
  }

  constructor (el) {
    this.el = $(el)
    this._readDataAttributes()
    this._hideImages()
    this.start()
  }

  stop () {
    clearInterval(this.interval)
  }

  start () {
    this.interval = setInterval(() => { this._loop() }, this.delay)
  }

  _readDataAttributes () {
    this.delay = this.el.data('slideshow-delay')
  }

  _hideImages () {
    this.el.find('.c-slideshow__slide:gt(0)').hide()
  }

  _loop () {
    this.el.find('.c-slideshow__slide:first')
      .fadeOut(50)
      .next()
      .fadeIn(50)
      .end()
      .appendTo('.c-slideshow__container')
  }
}
